import { render, staticRenderFns } from "./UserRequests.vue?vue&type=template&id=1b060307&scoped=true&"
import script from "./UserRequests.vue?vue&type=script&lang=js&"
export * from "./UserRequests.vue?vue&type=script&lang=js&"
import style0 from "./UserRequests.vue?vue&type=style&index=0&id=1b060307&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b060307",
  null
  
)

export default component.exports